export const ModeEnum = Object.freeze({
    car: 'car',
    bike: 'bike',
    foot: 'foot',
    motorcycle:'motorcycle'
})